import React, { useEffect, useState } from "react";
import api from "../../../Services/api";
import { useHistory } from "react-router-dom";
import { GridActionsCellItem } from "@mui/x-data-grid";
import ReactLoading from "react-loading";
import SidebarMenu from "../../../Components/SidebarMenu";
import { Page, PageTitle, ErrorMsg, ErrorBtn } from "./styles";
import { BsEyeFill, BsArrowRight, BsArrowLeft } from "react-icons/bs";

import { useAuth } from "../../../Hooks/useAuth";
import Tabela from "../../../Components/Tabela";
import StatusDisplay from "../../../Components/Status";

import { Tab, TabsContainer, Text, Label, Input, Button } from "./styles";
import DataTable from 'react-data-table-component';
import CreatableSelect from "react-select/creatable";
import Select from 'react-select';
import ExportCSVButton from "../../../Components/ExportCSVButton";
import PageContainer from "../../../Components/PageContainer";

export default function PagamentosAdministrador() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [errorRepositories, setErrorRepositories] = useState(null);
  const [transferencias, setTransferencias] = useState([]);
  const [infoPagina, setInfoPagina] = useState(
    {
      has_next: false,
      has_previous: false,
      per_page: 20,
      page: 1,
      total: 0,
    }
  );
  const [filtros, setFiltros] = useState({
    status: null,
    status_admin: null,
    procedimento: false,
    dataCriacaoMin: null,
    dataCriacaoMax: null,
  });
  const [quantidadeExibidaNaTabela, setQuantidadeExibidaNaTabela] = useState({label: "20", value: 20});
  const [statusExibidoNaTabela, setStatusExibidoNaTabela] = useState({label: "Todos", value: null});
  const [statusAdminExibidoNaTabela, setStatusAdminExibidoNaTabela] = useState({label: "Todos", value: null});

  const dropdownCustomStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "10vw",
      minHeight: "30px",
      borderRadius: "10px",
      backgroundColor: "#fafafa",
      fontSize: "18px",
      color: "black",
      border: "1px solid #d5d5d5",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "black", // Cor do texto das opções
    }),
  };

  const opcoesQuantidadeExibidos = [
    {label: "5", value: 5},
    {label: "10", value: 10},
    {label: "15", value: 15},
    {label: "20", value: 20}
  ];

  const opcoesStatus = [
    {label: "Sucesso", value: 'SUCESSO'},
    {label: "Falha", value: 'FALHA'},
    {label: "Insuficiente", value: 'INSUFICIENTE'},
    {label: "Pendente", value: 'PENDENTE'},
    {label: "Todos", value: null}
  ];

  const opcoesStatusAdmin = [
    {label: "Sucesso", value: 'SUCESSO'},
    {label: "Falha", value: 'FALHA'},
    {label: "Pendente", value: 'PENDENTE'},
    {label: "Todos", value: null}
  ];

  const colunasTabela = [
    {
      name: 'Medico',
      selector: row => (row.medico.usuario.NO_primeiro_nome ?? "" + " " + row.medico.usuario.NO_ultimo_nome ?? ""),
      sortable: true
    },
    {
      name: 'Titular/Afiliado',
      selector: row => !row.afiliado ? 
      (row.paciente.usuario.NO_primeiro_nome ?? "" + " " + row.paciente.usuario.NO_ultimo_nome ?? "" + " - Titular")
      : (row.afiliado.usuario.NO_primeiro_nome ?? "" + " " + row.afiliado.usuario.NO_ultimo_nome ?? "" + " - Afiliado"),
      sortable: true,
    },
    {
      name: 'Data de Criação',
      selector: row => new Date(row.DT_criacao).toLocaleDateString("pt-BR"),
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => row.ST_transferencia,
      sortable: true
    },
    {
      name: 'Status do Admin',
      selector: row => row.ST_transferencia_admin,
      sortable: true
    },
    {
      name: 'Valor',
      maxWidth: '50px',
      selector: row => row.QT_credito,
      sortable: true
    },
    {
      name: '',
      maxWidth: '40px',
      selector: row => 
      <BsEyeFill
      className="cursor-pointer" 
      onClick={() => {
        history.push(`/pagamentos-administrador/${row.id_transferencia}`);
      }} size={20} color="#7A99E3" 
      />,
    },
  ];

  useEffect(() => {
    fetchTransferenciasData();
  }, [filtros, infoPagina.page, infoPagina.per_page]);

  function toQueryString(params) {
    const query = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null) // pula null/undefined
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
  
    return query ? `?${query}` : '';
  }

  const fetchTransferenciasData = async () => {
    setLoading(true);
    setErrorRepositories(null);

    const filtroQuery = toQueryString(filtros);
    console.log("filtroQuery", filtroQuery);

    try {
      const response = await api.get(`/transferencia/visao-admin${filtroQuery}&page=${infoPagina.page}&per_page=${infoPagina.per_page}`);
      console.log("response.data", response.data);
      setTransferencias(response.data.transferencias);
      setInfoPagina(
        {
          ...infoPagina,
          has_next: response.data.has_next,
          has_previous: response.data.has_previous,
          total: response.data.total,
        }
      );
    } catch (error) {
      setErrorRepositories("Ocorreu um erro ao carregar a página");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const proximaPagina = async (proxima) => {
    console.log("foi de next");
    if (proxima) {
      setInfoPagina({ ...infoPagina, page: infoPagina.page + 1 });
    }
    else {
      setInfoPagina({ ...infoPagina, page: infoPagina.page - 1 });
    }
  };

  const mudarQuantidadeExibida = async(quantidade) => {
    setQuantidadeExibidaNaTabela(quantidade);
    setInfoPagina({ ...infoPagina, per_page: quantidade.value });
  }

  function refresh() {
    window.location.reload();
  }

  if (errorRepositories) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <PageTitle>Pagamentos</PageTitle>
          <ErrorMsg>{errorRepositories}</ErrorMsg>
          <ErrorBtn onClick={refresh}>Tentar novamente</ErrorBtn>
        </PageContainer>
      </Page>
    );
  }

  if (loading) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <PageTitle>Pagamentos</PageTitle>
          <ReactLoading
            type="spin"
            color="#B2EBF2"
            height={"30px"}
            width={"30px"}
          />
        </PageContainer>
      </Page>
    );
  }

  return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <SidebarMenu />
              <PageTitle>Pagamentos</PageTitle>
              <div className="flex flex-row w-full justify-center items-center mb-4 space-x-2">
                {/* Botões para alternar entre consulta e procedimento */}
                  <div className={
                    !filtros.procedimento
                    ?
                    "rounded-lg py-2 px-4 bg-roxo border-roxo border-solid border-[2px] font-semibold text-lg text-white"
                    :
                    "rounded-lg py-2 px-4 bg-white border-roxo border-solid border-[2px] font-semibold text-lg cursor-pointer hover:bg-[#EFCA04]"
                  } 
                  onClick={() => {
                    filtros.procedimento && setFiltros({ ...filtros, procedimento: false });
                  }}>
                    Consultas
                  </div>
                  <div 
                  className={
                    filtros.procedimento
                    ?
                    "rounded-lg py-2 px-4 bg-roxo border-roxo border-solid border-[2px] font-semibold text-lg text-white"
                    :
                    "rounded-lg py-2 px-4 bg-white border-roxo border-solid border-[2px] font-semibold text-lg cursor-pointer hover:bg-[#EFCA04]"
                  } 
                  onClick={() => {
                    !filtros.procedimento && setFiltros({ ...filtros, procedimento: true });
                  }}>
                    Procedimentos
                  </div>
              </div>
              <div className="flex flex-col w-full space-y-2 mr-4">
                  <div className="flex flex-row w-full justify-between items-center">
                    {/* Dropdown */}
                    <>
                      <>
                        <p className="text-black font-bold pr-2">Exibir:</p>
                        <CreatableSelect
                          options={opcoesQuantidadeExibidos}
                          required
                          value={quantidadeExibidaNaTabela}
                          onChange={(e) => {
                            e.value > 20 ? mudarQuantidadeExibida(opcoesQuantidadeExibidos.at(-1)) : mudarQuantidadeExibida(e);
                          }}
                          styles={dropdownCustomStyles}
                          placeholder={"Selecione a quantidade que será exibida na tabela"}
                        />
                      </>
                      <>
                        <p className="text-black font-bold pl-4 pr-2">Status:</p>
                        <Select
                          options={opcoesStatus}
                          required
                          value={statusExibidoNaTabela}
                          onChange={(e) => {
                            e.value !== filtros.status && setFiltros({ ...filtros, status: e.value });
                            setStatusExibidoNaTabela(e);
                          }}
                          styles={dropdownCustomStyles}
                          placeholder={"Selecione o status que deseja exibir"}
                        />
                      </>
                      <>
                        <p className="text-black font-bold pl-4 pr-2">Status Admin:</p>
                        <Select
                          options={opcoesStatusAdmin}
                          required
                          value={statusAdminExibidoNaTabela}
                          onChange={(e) => {
                            e.value !== filtros.status_admin && setFiltros({ ...filtros, status_admin: e.value });
                            setStatusAdminExibidoNaTabela(e);
                          }}
                          styles={dropdownCustomStyles}
                          placeholder={"Selecione o status que deseja exibir"}
                        />
                      </>
                    </>

                    <ExportCSVButton exportData={transferencias} />
                  </div>
                  <div className="w-full overflow-x-auto overflow-y-visible">
                    <DataTable
                      columns={colunasTabela}
                      data={transferencias}
                      responsive
                      customStyles={{
                        headCells: {
                          style: {
                            backgroundColor: "#EFCA04",
                            fontSize: "16px",
                          },
                        },
                      }}
                    />
                  </div>
  
                  <div className="flex flex-row w-full justify-between items-center">
                    <BsArrowLeft 
                    className={infoPagina.has_previous ? "cursor-pointer" : "cursor-not-allowed"}
                    onClick={() => infoPagina.has_previous && proximaPagina(false)} 
                    size={50} 
                    color={infoPagina.has_previous ? "#663780" : "#e0d7e6"} />
                    <p className="text-roxo">
                      {infoPagina.page + "/" + Math.ceil(infoPagina.total/infoPagina.per_page)}
                    </p>
                    <BsArrowRight 
                    className={infoPagina.has_next ? "cursor-pointer" : "cursor-not-allowed"}
                    onClick={() => infoPagina.has_next && proximaPagina(true)} 
                    size={50} 
                    color={infoPagina.has_next ? "#663780" : "#e0d7e6"} />
                  </div>
                </div>
        </PageContainer>
      </Page>
    );
}
